module.exports = __webpack_public_path__ + "static/media/sunset-investing-screenshot-4.fdb987b1.jpg";